import { useTranslation } from "react-i18next";

const Banner = () => {
    const { t } = useTranslation('common');

    return (
        <div className="container flex items-center justify-center">
            <div className="w-full h-full grid grid-cols-1 msm:grid-cols-3 items-center xl:flex py-[30px] msm:py-[50px] xlx:py-[65px] gap-[30px] xlx:gap-[50px]">
                <div className="w-full xl:w-auto flex items-center justify-center">
                    <img src={require("../../../assets/images/contact-us1.png")} alt="banner-img" />
                </div>
                <div className="flex items-center justify-center flex-col gap-[8px] w-full xl:w-fit">
                    <h2 className="text-primaryText dark:text-white font-bold text-center">{t("contact_us.title")}</h2>
                    <h6 className="text-blackDull dark:text-textBlackDull font-medium text-center max-w-[445px]">{t("contact_us.desc")}</h6>
                </div>
                <div className="w-full xl:w-auto flex items-center justify-center">
                    <img src={require("../../../assets/images/contact-us2.png")} alt="banner-img" />
                </div>
            </div>
        </div>
    );
};

export default Banner;